<template>
  <div style="position: relative;" v-if='onlinestate=="pc" && true'>
    <!-- <img :src="$lang.hongd_img" alt="" style="width: 100%;"> -->
    <img @dragstart.prevent :src="params.alldownload_under_pic" alt="" style="width: 100%;">
    <div class='btn_three'>
      <!-- require('@/image/home/IOS.png') -->
      <img @dragstart.prevent :src="params.alldownload_ios_pic" alt="" style="width: 9.5rem;    height: 3.5rem;">
      <img @dragstart.prevent :src="params.alldownload_androidgoogle_pic" alt="" style="width: 9.5rem;height: 3.5rem;">
      <img @dragstart.prevent :src="params.alldownload_androidapp_pic" alt="" style="width: 9.5rem;height: 3.5rem;">
      <!-- <img :src="params.alldownload_ios_pic" alt="" style="width: 9.5rem;    height: 3.5rem;"
        @click='handff(params.alldownload_ios_url)'>
      <img :src="params.alldownload_androidgoogle_pic" alt="" style="width: 9.5rem;height: 3.5rem;"
        @click='handff(params.alldownload_androidgoogle_url)'>
      <img :src="params.alldownload_androidapp_pic" alt="" style="width: 9.5rem;height: 3.5rem;"
          @click='handff(params.alldownload_androidapp_url)'> -->
      <!-- <img :src="$lang.Android" alt="" style="width: 9.5rem;height: 3.5rem;"
        @click='handff("https://hk.iqmis.com/app/apk/qmisopen.apk")'> -->
    </div>
    <handitem v-if='handis' @child='text($event)'></handitem>
  </div>
  <div style="position: relative;" v-else >
    <img :src="params.alldownload_under_pic" alt="" style="width: 100%;" @click='golandpage'>
    <div class='btn_three_model'>
      <img :src="params.alldownload_ios_pic" alt="" class='isimg'>
      <img :src="params.alldownload_androidgoogle_pic" alt="" class='isimg'>
      <img :src="params.alldownload_androidapp_pic" alt="" class='isimg'>
    </div>
    <!-- <div class='btn_three_model'>
      <img :src="params.alldownload_ios_pic" alt="" class='isimg'
        @click='handff(params.alldownload_ios_url)'>
      <img :src="params.alldownload_androidgoogle_pic" alt="" class='isimg'
        @click='handff(params.alldownload_androidgoogle_url)'>
      <img :src="params.alldownload_androidapp_pic" alt="" class='isimg'
        @click='handff(params.alldownload_androidapp_url)'>
    </div> -->
    <handitem v-if='handis' @child='text($event)'></handitem>
  </div>
</template>

<script>
import handitem from './handitem.vue'
  export default {
    components:{handitem},
    data(){
      return{
        handis:false,
        onlinestate:sessionStorage['onlinestate'],
        // onlinestate:'ipad',
        params:{},
        connect:''
      }
    },
    mounted() {
      this.getdate()
    },
    methods: {
      golandpage(){
        console.log('---')
        this.$router.push({path:"/account_opening_online"})
      },
      getdate(){
        this.$ajax({
          method:'post',
          url:this.$api.getAlldownloads
        }).then(res=>{
          if(res.data.qmiscode == 1000){
            this.params = res.data
          }
        })
      },
      // 外連按鈕
      handff(v) {
        this.handis= true;
        this.connect = v
        // window.open(v)
        
      },
      text(event){
        if (event == 0) {
          this.handis= false;
        }else if(event == 1){
          this.handis= false;
          window.open(this.connect)
        }
      }
    }
  }
</script>

<style scoped>
  .btn_three {
    position: absolute;
    top: 10rem;
    left: 12.5%;
    display: flex;
    justify-content: space-between;
    width: 34rem;
  }
  .btn_three>img{cursor:pointer;}
  .btn_three_model{
    position: absolute;
    top: 7.5rem;
    left: 3%;
    display: flex;
    justify-content: space-between;
    width: 14rem;
  }
  .btn_three_model>img{cursor:pointer;}
  @media screen and (max-width: 1100px){
    .btn_three_model{
      top: 11rem;
      width: 22rem;
    }
    .isimg{
      width:6.5rem;
      height: 2.5rem;
    }
  }
  @media screen and (max-width: 600px){
    .btn_three_model{
      top: 6.5rem;
      width: 14rem;
    }
    .isimg{
      width: 4.2rem;height: 1.4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/foot/footes.vue